import { HTMLProps } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { APP_HEADER_HEIGHT } from './constants';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: theme.spacing(2),

      // position
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: APP_HEADER_HEIGHT,

      // appearance
      background: theme.palette.navigation.background,
      color: theme.palette.navigation.selectedColor,
      zIndex: theme.zIndex.appBar,
      padding: theme.spacing(2, 2.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  });

export interface AppHeaderRootProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const AppHeaderRoot = (props: AppHeaderRootProps) => {
  const { className, classes, ...rest } = props;
  return <header className={classNames(classes.root, className)} {...rest} />;
};

export default withStyles(styles, { name: 'AppHeaderRoot' })(AppHeaderRoot);
